module.exports = __webpack_public_path__ + "img/bottom.6b4b22a2.png";